export default {
  computed: {
    pathMixin_isMeeting() {
      return Boolean(
        this.$route.path.match(/(^\/meetings(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
      );
    },
    pathMixin_isWorldStridesEnvisionLandingPage() {
      return this.$route.path === "/envision";
    },

    pathMixin_isBookingPage(){
      return Boolean(
          this.$route.path.match(/(^\/search(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
      );
    },

    pathMixin_isBookingPageWithoutTravelerBar(){
      return Boolean(
          this.$route.path.match(/(^\/search(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
          && this.$route.path !== "/search"
          && this.$route.path !== "/search/"
      );
    }
  },
};
